import { z } from 'zod';
import { cursorPageQuerySchema } from './pagination';

// Registro de auditoría (RF-08.15).

export const auditEventSchema = z
  .object({
    id: z.uuid(),
    occurredAt: z.iso.datetime(),
    actorId: z.uuid().nullable(),
    action: z.string(),
    objectType: z.string(),
    objectId: z.string(),
    before: z.unknown(),
    after: z.unknown(),
    reason: z.string(),
    ip: z.string().nullable(),
    requestId: z.string().nullable(),
  })
  .meta({ id: 'AuditEvent' });

export const auditQuerySchema = cursorPageQuerySchema.extend({
  actorId: z.uuid().optional(),
  action: z.string().max(60).optional(),
  objectType: z.string().max(40).optional(),
  objectId: z.string().max(80).optional(),
});
